import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../../api/MobileAPI';
export function useNotifications(isSignedIn) {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const refresh = useCallback(async () => {
        if (!isSignedIn)
            return;
        setLoading(true);
        try {
            const data = await apiFetch('/api/user/notifications');
            setNotifications(data);
        }
        catch {
            // silently ignore - notifications are non-critical
        }
        finally {
            setLoading(false);
        }
    }, [isSignedIn]);
    useEffect(() => {
        void refresh();
    }, [refresh]);
    useEffect(() => {
        if (!navigator.serviceWorker)
            return;
        const handler = (event) => {
            if (event.data?.type === 'PUSH_RECEIVED')
                void refresh();
        };
        navigator.serviceWorker.addEventListener('message', handler);
        return () => navigator.serviceWorker.removeEventListener('message', handler);
    }, [refresh]);
    const markRead = useCallback(async (id) => {
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
        try {
            await apiFetch(`/api/user/notifications/${encodeURIComponent(id)}/read`, { method: 'PUT' });
        }
        catch {
            void refresh();
        }
    }, [refresh]);
    const markAllRead = useCallback(async () => {
        setNotifications(prev => prev.map(n => ({ ...n, read: true })));
        try {
            await apiFetch('/api/user/notifications/read-all', { method: 'PUT' });
        }
        catch {
            void refresh();
        }
    }, [refresh]);
    const clearAll = useCallback(async () => {
        setNotifications([]);
        try {
            await apiFetch('/api/user/notifications', { method: 'DELETE' });
        }
        catch {
            void refresh();
        }
    }, [refresh]);
    const deleteOne = useCallback(async (id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
        try {
            await apiFetch(`/api/user/notifications/${encodeURIComponent(id)}`, { method: 'DELETE' });
        }
        catch {
            void refresh();
        }
    }, [refresh]);
    const unreadCount = notifications.filter(n => !n.read).length;
    return { notifications, unreadCount, loading, refresh, markRead, markAllRead, clearAll, deleteOne };
}
